import React from 'react';
import { Button } from 'primereact/button';
import CustomTooltip from '../../../../../shared/components/common/tooltip/CustomTooltip';
import { TagsResponse } from '../../../../../shared/models/tags/TagsResponse';

interface ActionBtnProps {
  projectId: number;
  tag: TagsResponse;
  accountStatus: string;
  onEdit: (projectId: number, tag: TagsResponse) => void;
  removeTag: (tagId: number) => void;
}

const ActionBtn: React.FC<ActionBtnProps> = ({ projectId, tag, accountStatus, onEdit, removeTag }) => {
  return (
    <div className="buttons-list">
      <>
        <Button
          id={`btn-edit-tag-${projectId}`}
          className="action-btn"
          onClick={() => onEdit(projectId, tag)}
        >
          <span className="ico--edit ico--xs" />
        </Button>
        <CustomTooltip tooltipText="editTag" targetRef={`btn-edit-tag-${projectId}`} />
      </>
      <Button
        id={`btn-remove-tag-${projectId}`}
        className={`action-btn material-symbols-outlined`}
        onClick={() => removeTag(tag.id)}
      >
        <span className="ico--trash ico--xs" />
        <CustomTooltip tooltipText="removeTag" targetRef={`btn-remove-tag-${projectId}`} />
      </Button>
    </div>
  );
};

export default ActionBtn;
